import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";
import { internalAxiosClient } from "utilz/helpers/apiRequestAuthHelper";

/**
 * @deprecated This function is deprecated with Logto integration
 * Logout is now handled by Logto SDK via useLogto().signOut()
 * This function is kept for backward compatibility during migration
 */
export const logOutAccount = async () => {
  try {
    const result = await internalAxiosClient.post(
      "/logout",
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      }
    );
    return result;
  } catch (e: any) {
    if (
      e &&
      e?.response &&
      (e?.response?.data?.message === "unauthorized" ||
        e?.response?.data?.error === "Refresh token not found")
    ) {
      throw new Error("unauthorized");
    }
    throw new Error(e);
  }
};

export const preLogin = async (email: string) => {
  try {
    const url = "/v2/generalRoute/vanity/prelogin";
    const response = await axiosClient.post(`${url}`, { email });
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const checkUserAuth = async () => {
  try {
    const url = "/auth/user";
    // console.log("url", url);
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    // if (resData.success && resData.statusCode === 200) {
    // console.log("resData", resData);
    return resData;
    // }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const resendInvitation = async ({
  userId,
  tenantId,
}: {
  userId: string;
  tenantId: string;
}) => {
  try {
    const url = "/auth/user/resend-invitation";
    const response = await axiosClient.post(url, {
      userId,
      tenantId,
    });
    const resData = response?.data;
    if (resData?.statusCode === 200 && resData?.success) {
      return resData;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const silentSignout = async ({
  clientId,
  token,
}: {
  clientId: string;
  token: string;
}) => {
  try {
    const url = `${import.meta.env.VITE_LOGTO_ENDPOINT}/oidc/token/revocation`;
    const response = await axiosClient.post(url, {
      client_id: clientId,
      token,
    });
    const resData = response?.data;
    if (resData?.statusCode === 200 && resData?.success) {
      return resData;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
